import type { AdvisorData } from '../../utils/types'

/**
 * Match types come from the visible matches only. `window.matches` is already
 * filtered by SAapp to lead-engine's persisted top-3 matches, so the slice is defensive.
 */
export const VISIBLE_MATCH_LIMIT = 3

/**
 * Collects the distinct `match_product_type` values (e.g. CPM, CPL, CPML, ROBO, AUM, AMP) from
 * the up-to-three visible matches. Values are trimmed and uppercased; null/empty product types
 * are skipped. Returns an empty set when there are no matches.
 */
export function deriveMatchTypes (matches: AdvisorData[] | undefined): Set<string> {
  const types = new Set<string>()
  if (!Array.isArray(matches)) {
    return types
  }
  matches.slice(0, VISIBLE_MATCH_LIMIT).forEach((match) => {
    const raw = match?.advisor?.network?.match_product_type
    const normalized = typeof raw === 'string' ? raw.trim().toUpperCase() : ''
    if (normalized) {
      types.add(normalized)
    }
  })
  return types
}
